{
  "postTradingFilter": {
    "searchTicker": "Введите тикер",
    "operationType": "Тип операции",
    "selectType": "Выберите тип"
  }
}
